let comps = {};

const files = require.context('./', true, /\.vue$/);

// 遍历files对象，构建components键值
files.keys().forEach(key => {
    comps[key.replace(/(\.\/|\.vue)/g, '')] = files(key).default
});

export default comps;
